import { render, staticRenderFns } from "./PreorderHistorySection.vue?vue&type=template&id=67547be8&scoped=true"
import script from "./PreorderHistorySection.vue?vue&type=script&lang=js"
export * from "./PreorderHistorySection.vue?vue&type=script&lang=js"
import style0 from "./PreorderHistorySection.vue?vue&type=style&index=0&id=67547be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67547be8",
  null
  
)

export default component.exports